var render = function render(){var _vm=this,_c=_vm._self._c;return _c('horizontal-nav',{attrs:{"items":_vm.items,"prop_name":"street","set_view":true,"show_display":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }